import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class InfoIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">

				<path fill="currentColor" d="M512 0c-283.006 0-512 229.014-512 512 0 283.006 229.014 512 512 512 283.006 0 512-229.014 512-512 0-283.006-229.016-512-512-512zM512 944c-238.786 0-432-193.23-432-432 0-238.786 193.23-432 432-432 238.786 0 432 193.23 432 432 0 238.786-193.232 432-432 432z"></path>
				<path fill="currentColor" d="M512 428.66c-22.092 0-40 17.908-40 40v257.586c0 22.092 17.908 40 40 40s40-17.91 40-40.002v-257.584c0-22.092-17.908-40-40-40z"></path>
				<path fill="currentColor" d="M566 325.68c0 29.823-24.177 54-54 54s-54-24.177-54-54c0-29.823 24.177-54 54-54s54 24.177 54 54z"></path>

			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}
